// Small configuration boundary: no SDK is imported by API configuration.
export const analyticsConfig = {
  enabled: process.env.REACT_APP_AMPLITUDE_ENABLED === 'true',
  apiKey: process.env.REACT_APP_AMPLITUDE_API_KEY || '',
  serverZone:
    process.env.REACT_APP_AMPLITUDE_SERVER_ZONE === 'EU' ? ('EU' as const) : ('US' as const),
  environment: process.env.REACT_APP_AMPLITUDE_ENVIRONMENT || 'unknown',
  replayEnabled: process.env.REACT_APP_AMPLITUDE_REPLAY_ENABLED === 'true',
  releaseVersion: process.env.REACT_APP_AMPLITUDE_RELEASE_VERSION || 'unversioned',
  projectFingerprint: process.env.REACT_APP_AMPLITUDE_PROJECT_FINGERPRINT || 'unconfigured',
  // A non-secret stamp lets the release checker identify the compiled configuration.
  buildStamp: process.env.REACT_APP_AMPLITUDE_BUILD_STAMP || '',
};
